export default {"src":"/_next/static/media/A Twin.16ac921c.svg","height":60,"width":108};